// extracted by mini-css-extract-plugin
module.exports = {"lightbox":"lightbox_lightbox__jS8aS"};